import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchCampaignGallery as fetchCampaignGalleryAPI, fetchCampaignCreatives as fetchCampaignCreativesAPI } from "services/api/campaign";
import { ERROR } from "types";
import { Campaign } from "types/campaign";
import { CreativesSlice, GallaeryImage } from "types/campaign/creatives";
import { getErrorMessage, isFresh } from "utils/helpers";

const staleTime = apiConfig.FETCH_CAMPAIGN_CREATIVES.staleTime;

export const fetchCampaignCreatives = createAsyncThunk<
    { campaignId: string, campaign: Campaign, gallery: GallaeryImage[] },
    { campaignId: string, force?: boolean },
    { rejectValue: string }
>(
    'campaign/creatives',
    async ({ campaignId, force }, { getState, rejectWithValue }) => {
        const state = getState() as { campaignCreatives: CreativesSlice };
        if (!force && isFresh(state.campaignCreatives.campaigns[campaignId]?.last_fetched_at, staleTime)) {
            return rejectWithValue(ERROR.CACHED);
        }
        try {
            const { campaign } = await fetchCampaignCreativesAPI(campaignId);
            const gallery = await fetchCampaignGalleryAPI(campaignId);
            return { campaignId, campaign, gallery };
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, "Failed to fetch campaign creatives"));
        }
    }
);
